import React, { useState, useEffect } from 'react';
import images from '../../constants/images'
import './EventBanner.css'
const EventBanner = ({ expiryDate }) => {
    const [timeLeft, setTimeLeft] = useState({});
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const calculateTimeLeft = () => {
            const now = new Date();
            const expiration = new Date(expiryDate);
            const difference = expiration - now;

            if (difference <= 0) {
                setVisible(false);
                return;
            }

            const time = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / (1000 * 60)) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };

            setTimeLeft(time);
        };

        // Initial run
        calculateTimeLeft();

        // Update every second
        const interval = setInterval(calculateTimeLeft, 1000);

        return () => clearInterval(interval);
    }, [expiryDate]);

    if (!visible) return null;

    return (
        <div className="app__background section__padding">
            <div class="">
                <h3 className="h3__roboto-w" style={{ padding: '10px 0px' }}>Triva Night!</h3>
                <p style={{paddingBottom: '5px'}}>
                    We are looking for donations for our upcoming trivia night that will be held on Saturday, November 8th.
                    No donation is too big or too small.
                </p>
                <p style={{paddingBottom: '5px'}}>The purpose of the trivia night is to raise money for Illowa travel soccer to be played here in Orion.</p>
                <p style={{paddingBottom: '15px'}}>  Please contact Aaron Dean at <span style={{color: 'yellow'}}>309-798-9022</span> or Nicole Carlson at <span style={{color: 'yellow'}}>309-230-2251 </span>to arrange donations or if you have any questions.</p>
                <img style={{ width: '10rem' }} className="venmoImg" src={images.venmo} alt="venmo" />
                <p className="p__opensans" style={{ marginTop: '1rem', fontSize: '10px' }}>Payment Method - Venmo QR Code</p>
                <p>  {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s</p>
            </div>

        </div>
    );
};

export default EventBanner;
